import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavbarComponent from './components/navbar';
import HeroSection from './components/section';
import About from './assets/About';
import Postcard from './components/post';
import Testimonials from './components/review';
import ContactForm from './assets/contact'; 
import Pos from './assets/shop';
import Hero from './components/meow';

function App() {
  return (
    <Router>
      <NavbarComponent />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <Postcard />
              <Testimonials />
              <Hero />
            </>
          }
        />
        <Route path="/shop" element={<Pos />} /> 
        <Route path="/contact" element={<ContactForm />} /> 
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;


